var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent",style:(_vm.svgStyle),domProps:{"innerHTML":_vm._s(_vm.icon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }